import { getLocalTimeZone, today } from "@internationalized/date";
import { z } from "zod/v4";
import { nuqsBoolean, nuqsCommaArray } from "#/modules/util.pagination/search.nuqs";

/**
 * Search params schema for beweegresultaten (results) filters: date range, progress flags, leerlijn filter.
 */
export const beweegresultatenSearchSchema = z.object({
  from: z.string().nullable().default(null),
  to: z.string().nullable().default(null),
  includeWithProgress: nuqsBoolean(true),
  includeWithoutProgress: nuqsBoolean(true),
  selectedLeerlijnFilterIds: nuqsCommaArray,
});

/** Default values for beweegresultaten search params; values not explicitly set will be omitted from URL. */
export type BeweegresultatenSearch = z.infer<typeof beweegresultatenSearchSchema>;

export const BEWEEGRESULTATEN_SEARCH_DEFAULTS: Pick<
  BeweegresultatenSearch,
  "from" | "to" | "includeWithProgress" | "includeWithoutProgress" | "selectedLeerlijnFilterIds"
> = {
  from: null,
  to: null,
  includeWithProgress: true,
  includeWithoutProgress: true,
  selectedLeerlijnFilterIds: [],
};

/** Unchanged from the deleted `filters.student.beweegresultaten.ts` (byte-identical logic). */
export function getDefaultDateRange() {
  const todayDate = today(getLocalTimeZone());
  const startOfYear = todayDate.set({ month: 1, day: 1 });
  const endOfYear = todayDate.set({ month: 12, day: 31 });
  return {
    from: startOfYear.toString(),
    to: endOfYear.toString(),
  };
}
